export const AUTOMATION_EN = {
    'nav.module.automation': 'Automation',
    'automation.refusal.required': 'This is required.',
    'automation.refusal.text': 'Write this as text.',
    'automation.refusal.too_long': 'At most {max} characters.',
    'automation.refusal.number': 'A whole number from {min} to {max}.',
    'automation.refusal.trigger': 'Choose what starts the rule.',
    'automation.refusal.trigger_not_yet': 'A date cannot start a rule yet: choose an event or a schedule.',
    'automation.refusal.schedule': 'Choose every day or every week, a time as HH:MM, and for a week its day.',
    'automation.refusal.schedule_event_field': 'A scheduled rule starts from no event, so it has no fields to test or read.',
    'automation.refusal.schedule_record': 'A scheduled rule is about no record: it cannot make activities, branch, send signals, or take records in and out.',
    'automation.refusal.signal': 'Choose what to ask for, from the list, with its values.',
    'automation.refusal.signal_permission': 'Choose a permission of the module that is asked ({module}).',
    'automation.refusal.event': 'Choose an event from the list.',
    'automation.refusal.event_own': 'A rule cannot start from what automation itself does.',
    'automation.refusal.subject': 'Choose which record the event is about.',
    'automation.refusal.field': 'Choose a field of the event.',
    'automation.refusal.operator': 'Choose a comparison from the list.',
    'automation.refusal.value': 'This comparison needs a different value.',
    'automation.refusal.conditions': 'The conditions could not be read.',
    'automation.refusal.nesting': 'Groups go one level deep, as on a list.',
    'automation.refusal.too_many': 'At most {max}.',
    'automation.refusal.action': 'Choose what to do.',
    'automation.refusal.action_type': 'Choose an action from the list.',
    'automation.refusal.actions': 'A rule has to do something besides waiting.',
    'automation.refusal.trailing_wait': 'A wait at the end puts nothing off: remove it.',
    'automation.refusal.wait_one': 'A wait is minutes or working days, not both.',
    'automation.refusal.channel': 'Choose WhatsApp, SMS, email or the party\'s portal.',
    'automation.refusal.portal_marketing': 'The portal carries messages about the party\'s own records, never marketing.',
    'automation.refusal.on_fail_message': 'A message instead goes on another channel, and has nothing instead of itself.',
    'automation.refusal.recipe_unknown': 'No module this workspace has on ships the recipe «{value}».',
    'automation.refusal.recipe_empty': 'The recipe «{value}» ships no automation rules.',
    'automation.refusal.recipe_invalid': 'A rule of this recipe ({item}) is not one this workspace may keep. Tell the product team.',
    'automation.refusal.purpose': 'Choose what the message is for.',
    'automation.refusal.template': 'Choose a template the workspace keeps, and fill its words.',
    'automation.refusal.on_fail': 'What is done instead is a notice, an activity or a message on another channel.',
    'automation.refusal.listen': 'Name the event and the field of it that names the record.',
    'automation.refusal.branch_last': 'A branch is the last step of its list: put what follows it in its arms.',
    'automation.refusal.branch_depth': 'A branch goes at most {max} deep.',
    'automation.refusal.record_needed': 'This is about a record: choose which field of the event names it.',
    'automation.refusal.roles': 'Choose up to {max} roles.',
    'automation.refusal.nobody': 'Choose who is told: roles, the person the event names, or you.',
    'automation.refusal.importance': 'Choose information or warning.',
    'automation.refusal.activity_kind': 'A rule makes a task or a call.',
    'automation.refusal.activity_subject': 'An activity is kept on a record: choose which record the event is about.',
    'automation.refusal.assignee': 'Choose a member of this workspace.',
    'automation.refusal.assignee_unnamed': 'The members could not be read: write the name of the person it is for.',
    'automation.refusal.url': 'A web hook is an https address with no password in it.',
    'automation.refusal.status': 'Choose on or paused.',
    'automation.refusal.action_not_permitted': 'You may not make a rule do this: it needs {permission}.',
    'automation.refusal.no_key': 'Web hooks are not set up on this installation yet: ask the operator.',
    'automation.refusal.active_limit': 'At most {max} rules can be on at once: pause one first.',
    'automation.refusal.name_taken': 'Another rule has this name.',
    'automation.refusal.not_found': 'No such rule.',
    'automation.refusal.stale': 'The rule changed since you opened it. Reload and try again.',
    'automation.refusal.restore_expired': 'A rule can be brought back for {days} days after it was removed.',
    'automation.reason.loop_guard': 'Stopped: the rule ran too often on this record in an hour.',
    'automation.reason.answered': 'What it waited for came: it went on with «yes».',
    'automation.reason.message_not_sent': 'The message could not go; what was set instead was done.',
    'automation.reason.sent_instead': 'The message could not go on its channel; it went on the other one instead.',
    'automation.reason.timed_out': 'The time ran out with nothing heard: it went on with «no».',
    'automation.reason.exited': 'Taken out of the rule by an exit.',
    'automation.reason.goal_reached': 'Reached the rule\'s goal.',
    'automation.reason.met_lately': 'Not taken in: the rule met this record recently.',
    'automation.reason.rule_paused': 'Stopped: the rule was paused or removed.',
    'automation.reason.author_not_permitted': 'Stopped: whoever saved the rule may no longer do what it does.',
    'automation.reason.no_subject': 'The event did not say which record it is about.',
    'automation.reason.activity_refused': 'The activity was refused.',
    'automation.reason.already_told': 'Already told.',
    'automation.reason.nobody_told': 'Nobody could be told.',
    'automation.reason.no_secret': 'The rule has no web hook key.',
    'automation.reason.no_key': 'The web hook key could not be opened on this installation.',
    'automation.reason.webhook_answered': 'The address answered with an error.',
    'automation.reason.webhook_refused': 'The address is not one this system may reach.',
    'automation.reason.webhook_unreachable': 'The address did not answer.',
    'automation.reason.error': 'Something went wrong running this step.',
    // The follow-up flow builder and the list of flows (screens automation.rules and automation.builder).
    "nav.automation.rules": "Follow-up flows",
    "screen.automation.rules.title": "Follow-up flows",
    "screen.automation.rules.lede": "What happens by itself when something happens to a record: each flow runs on its author's word.",
    "screen.automation.rules.empty": "No flows yet. A new flow starts from the event it answers.",
    "screen.automation.rules.stat.active": "On",
    "screen.automation.rules.stat.paused": "Paused",
    "screen.automation.rules.stat.author_lost": "Stopped by themselves",
    "screen.automation.rules.stat.author_lost.detail": "Their author may no longer do what they do",
    "screen.automation.rules.column.name": "Flow",
    "screen.automation.rules.column.event_name": "Starts from",
    "screen.automation.rules.column.status": "State",
    "screen.automation.rules.column.runs_7d": "Runs in 7 days",
    "screen.automation.rules.column.last_run_at": "Last run",
    "screen.automation.rules.column.paused_reason": "Why it stopped",
    "screen.automation.rules.column.version": "Version",
    "screen.automation.rules.column.updated_at": "Changed",
    "screen.automation.rules.column.id": "Id",
    "screen.automation.rules.action.create": "New flow",
    "screen.automation.rules.action.open": "Open",
    "screen.automation.rules.action.pause": "Pause",
    "screen.automation.rules.action.resume": "Switch back on",
    "screen.automation.rules.action.remove": "Remove",
    "value.automation_rule.status.active": "On",
    "value.automation_rule.status.paused": "Paused",
    "value.automation_rule.paused_reason.author_not_permitted": "Its author lost the permission",
    "screen.automation.builder.title": "Follow-up flow",
    "screen.automation.builder.lede": "What starts it, what happens to every record in order, and how a record leaves it.",
    "value.automation_run.outcome.running": "Under way",
    "value.automation_run.outcome.done": "Done",
    "value.automation_run.outcome.failed": "Failed",
    "value.automation_run.outcome.stopped": "Stopped",
    "value.automation_run.outcome.skipped": "Not taken in",
    "automation.builder.name": "Name of the flow",
    "automation.builder.name.placeholder": "As the team calls it: «A new lead — answered in minutes»",
    "automation.builder.state.draft": "Draft — not saved",
    "automation.builder.state.active": "On · version {version}",
    "automation.builder.state.paused": "Paused · version {version}",
    "automation.builder.unsaved": "Unsaved changes",
    "automation.builder.warnings.one": "One warning",
    "automation.builder.warnings.many": "{n} warnings",
    "automation.builder.runs_as": "Runs on the word of {name}: what it does is asked of them before each step, and it pauses by itself if they lose that.",
    "automation.builder.author_you": "you, once you save it",
    "automation.builder.author_unknown": "the member who last saved it",
    "automation.builder.read_only": "You can see this flow. Changing it needs the permission to manage automation rules.",
    "automation.builder.safe_test": "Safe test",
    "automation.builder.pause": "Pause",
    "automation.builder.save": "Save",
    "automation.builder.save_draft": "Save as a draft",
    "automation.builder.save_changes": "Save changes",
    "automation.builder.activate": "Switch on the flow",
    "automation.builder.back": "Back",
    "automation.builder.reload": "Reload",
    "automation.builder.saved": "Saved, paused: nothing runs until it is switched on.",
    "automation.builder.switched_on": "Switched on. It answers events from now on.",
    "automation.builder.saved_version": "Saved as version {version}. Records already in the flow keep the version they started with.",
    "automation.builder.paused": "Paused. What was waiting is cancelled.",
    "automation.builder.refused": "Not saved: {n} to correct, marked where each is.",
    "automation.builder.fix_first": "{n} to correct before it can be saved, each marked where it is.",
    "automation.builder.and_more": "and {n} more",
    "automation.builder.removed": "The step was removed.",
    "automation.builder.missing": "No such flow",
    "automation.builder.down": "The flow could not be read",
    "automation.builder.down.lede": "Go back to the list of flows and open it again.",
    "automation.builder.untitled": "untitled",
    "automation.builder.pick_or_write": "Choose, or write the name",
    "automation.builder.use_written": "Use «{text}»",
    "automation.builder.none_seen": "None seen yet",
    "automation.builder.yes": "Yes",
    "automation.builder.no": "No",
    "automation.builder.sentence": "What happens to every record",
    "automation.builder.sentence.lede": "Press a coloured part to edit its step.",
    "automation.builder.sentence.start": "When «{event}» happens",
    "automation.builder.sentence.conditions.one": " and its condition holds",
    "automation.builder.sentence.conditions.two": " and its 2 conditions hold",
    "automation.builder.sentence.conditions.few": " and its {n} conditions hold",
    "automation.builder.sentence.conditions.many": " and its {n} conditions hold",
    "automation.builder.sentence.comma": ", ",
    "automation.builder.sentence.then": ", then ",
    "automation.builder.sentence.notify": "we tell {who}: «{title}»",
    "automation.builder.sentence.activity": "we make a {kind} for {who}: «{title}»",
    "automation.builder.sentence.webhook": "we send the event to the web hook",
    "automation.builder.sentence.wait": "we wait {duration}",
    "automation.builder.sentence.branch": "if «{event}» comes within {duration}",
    "automation.builder.sentence.branch_yes": " — ",
    "automation.builder.sentence.branch_no": "; if it does not, ",
    "automation.builder.sentence.ends": "the flow ends",
    "automation.builder.sentence.nothing": "nothing happens yet",
    "automation.builder.sentence.stop": ".",
    "automation.builder.sentence.exit": " A record leaves the flow as soon as «{events}» happens.",
    "automation.builder.sentence.or": "» or «",
    "automation.builder.sentence.goal": " Its goal: «{event}».",
    "automation.builder.sentence.once.one": " The same record comes in at most once a day.",
    "automation.builder.sentence.once.two": " The same record comes in at most once in 2 days.",
    "automation.builder.sentence.once.few": " The same record comes in at most once in {n} days.",
    "automation.builder.sentence.once.many": " The same record comes in at most once in {n} days.",
    "automation.builder.sentence.who.roles": "the roles {roles}",
    "automation.builder.sentence.who.field": "the person in «{field}»",
    "automation.builder.sentence.who.author": "the flow's author",
    "automation.builder.sentence.who.member": "the chosen member",
    "automation.builder.sentence.who.nobody": "nobody yet",
    "automation.builder.sentence.list": ", ",
    "automation.builder.sentence.and": " and ",
    "automation.builder.unit": "Unit",
    "automation.builder.unit.minutes": "Minutes",
    "automation.builder.unit.hours": "Hours",
    "automation.builder.unit.days": "Days",
    "automation.builder.unit.minutes.one": "1 minute",
    "automation.builder.unit.minutes.two": "2 minutes",
    "automation.builder.unit.minutes.few": "{n} minutes",
    "automation.builder.unit.minutes.many": "{n} minutes",
    "automation.builder.unit.hours.one": "1 hour",
    "automation.builder.unit.hours.two": "2 hours",
    "automation.builder.unit.hours.few": "{n} hours",
    "automation.builder.unit.hours.many": "{n} hours",
    "automation.builder.unit.days.one": "1 day",
    "automation.builder.unit.days.two": "2 days",
    "automation.builder.unit.days.few": "{n} days",
    "automation.builder.unit.days.many": "{n} days",
    "automation.builder.mode.build": "Build",
    "automation.builder.mode.performance": "Performance",
    "automation.builder.mode.test": "Test",
    "automation.builder.side.step": "The step",
    "automation.builder.side.rules": "Guardrails",
    "automation.builder.start": "Start",
    "automation.builder.end": "End",
    "automation.builder.arm.yes": "Yes",
    "automation.builder.arm.no": "No — time ran out",
    "automation.builder.add_here": "Add a step here",
    "automation.builder.add.title": "What goes here?",
    "automation.builder.add.lede": "Choose the kind of step: it goes where «+» was pressed.",
    "automation.builder.add.go": "Add the step",
    "automation.builder.has_problem": "To correct",
    "automation.builder.has_warning": "Warning",
    "automation.builder.remove_step": "Remove the step",
    "automation.builder.drop_branch": "Remove this check and both its arms?",
    "automation.builder.drop_branch.lede": "The steps in «yes» and in «no» go with it.",
    "automation.builder.selected": "The selected step",
    "automation.builder.card.branch": "Does «{event}» come within {duration}?",
    "automation.builder.type.notify": "Notice",
    "automation.builder.type.activity": "Activity",
    "automation.builder.type.wait": "Wait",
    "automation.builder.type.branch": "Check and branch",
    "automation.builder.type.webhook": "Web hook",
    "automation.builder.type.notify.hint": "on the bell of whoever you choose",
    "automation.builder.type.activity.hint": "a call or a task on the record",
    "automation.builder.type.wait.hint": "puts off what comes after it",
    "automation.builder.type.branch.hint": "happened / did not happen within a time",
    "automation.builder.type.webhook.hint": "a signed call to another system",
    "automation.builder.type.branch_only_last": "Check and branch — only at the end of a list",
    "automation.builder.kind.call": "call",
    "automation.builder.kind.task": "task",
    "automation.builder.trigger": "When does it start?",
    "automation.builder.trigger.lede": "An event any unit announces, and which of its fields names the record.",
    "automation.builder.event": "Event",
    "automation.builder.event.hint": "The events met here lately are offered; another may be written.",
    "automation.builder.about_record": "The event is about a record",
    "automation.builder.no_record": "Without a record, the flow can tell people and call a web hook, but cannot make an activity, wait for an answer, or let a record leave.",
    "automation.builder.subject_field": "Field that names the record",
    "automation.builder.subject_field.hint": "The record's id in the event, as lead_id.",
    "automation.builder.subject_entity": "Kind of record",
    "automation.builder.subject_entity.hint": "module.entity, as crm.lead.",
    "automation.builder.conditions": "And only if",
    "automation.builder.conditions.lede": "The event's fields, compared as a list filters them. None: every event.",
    "automation.builder.conditions.rel": "Holds when",
    "automation.builder.conditions.all": "all of them hold",
    "automation.builder.conditions.any": "any of them holds",
    "automation.builder.conditions.group": "Group",
    "automation.builder.conditions.field": "Field",
    "automation.builder.conditions.op": "Comparison",
    "automation.builder.conditions.value": "Value",
    "automation.builder.conditions.from": "From",
    "automation.builder.conditions.to": "To",
    "automation.builder.conditions.in_hint": "Values separated by commas",
    "automation.builder.conditions.add": "Add a condition",
    "automation.builder.conditions.add_group": "Add a group",
    "automation.builder.conditions.remove": "Remove the condition",
    "automation.builder.conditions.remove_group": "Remove the group",
    "automation.builder.op.eq": "is",
    "automation.builder.op.contains": "contains",
    "automation.builder.op.starts": "starts with",
    "automation.builder.op.in": "is one of",
    "automation.builder.op.gt": "more than",
    "automation.builder.op.lt": "less than",
    "automation.builder.op.between": "between",
    "automation.builder.op.on": "on the day",
    "automation.builder.op.before": "before",
    "automation.builder.op.after": "after",
    "automation.builder.op.is": "is yes / no",
    "automation.builder.notify.title": "What the notice says",
    "automation.builder.notify.importance": "Importance",
    "automation.builder.importance.info": "Information",
    "automation.builder.importance.warning": "Warning",
    "automation.builder.notify.to_author": "Tell the flow's author",
    "automation.builder.notify.user_field": "Tell the person the event names",
    "automation.builder.notify.user_field.hint": "A field holding a member, as the record's owner.",
    "automation.builder.notify.roles": "Tell these roles",
    "automation.builder.notify.no_roles": "The workspace's roles could not be listed: write a role's key.",
    "automation.builder.notify.add_role": "Add a role",
    "automation.builder.activity.kind": "Kind",
    "automation.builder.activity.due": "Due in (days)",
    "automation.builder.activity.due.hint": "0 for the same day.",
    "automation.builder.activity.title": "What is asked",
    "automation.builder.activity.notes": "Notes",
    "automation.builder.activity.assignee": "For",
    "automation.builder.activity.assignee.hint": "The flow's author, or a member of the workspace.",
    "automation.builder.activity.assignee.no_members": "The workspace's members could not be listed: the flow's author does it, or the member it was saved with.",
    "automation.builder.activity.assignee.author": "The flow's author",
    "automation.builder.webhook.url": "Address",
    "automation.builder.webhook.url.hint": "An https address, with no password in it.",
    "automation.builder.webhook.signed": "Each call is signed with a key made for this flow; it is shown once, when the flow is first saved with a web hook.",
    "automation.builder.wait.for": "Wait for",
    "automation.builder.branch.until": "Wait for this event",
    "automation.builder.branch.until.hint": "As «the customer replied».",
    "automation.builder.branch.field": "Its field that names the same record",
    "automation.builder.branch.field.hint": "So a reply about another record does not count.",
    "automation.builder.branch.within": "For at most",
    "automation.builder.branch.explain": "If it comes in time, the flow goes on with «yes» at once. If the time runs out, with «no» — a flow never stops silently.",
    "automation.builder.rules": "Guardrails",
    "automation.builder.rules.lede": "How a record leaves the flow, what the flow is for, and how often the same record may come in.",
    "automation.builder.rules.need_record": "These need the start to name its record.",
    "automation.builder.rules.exit": "A record leaves the flow when",
    "automation.builder.rules.exit.lede": "What waits for it is cancelled.",
    "automation.builder.rules.add_exit": "Add an event",
    "automation.builder.rules.remove_exit": "Remove the event",
    "automation.builder.rules.event": "Event",
    "automation.builder.rules.field": "Field that names the record",
    "automation.builder.rules.goal": "Goal",
    "automation.builder.rules.goal.lede": "Reaching it takes the record out too, and counts as «reached the goal».",
    "automation.builder.rules.has_goal": "This flow has a goal",
    "automation.builder.rules.once": "Once in a while",
    "automation.builder.rules.once.lede": "A record the flow met lately is not taken in again.",
    "automation.builder.rules.has_once": "Limit how often the same record comes in",
    "automation.builder.rules.once_days": "At most once every",
    "automation.builder.warn.empty_no": "The «no» arm is empty: whoever does not answer leaves the flow with nobody following up.",
    "automation.builder.warn.nobody_acts": "Nothing in the flow asks a person to act.",
    "automation.builder.warn.long_wait": "A long wait ({days} days): whoever it is for may have moved on.",
    "automation.builder.activate.title": "Switch on «{name}»",
    "automation.builder.activate.title_version": "Save «{name}» as version {version}",
    "automation.builder.activate.what": "From now on, every «{event}» that meets the conditions starts this flow. Events from before are not acted on.",
    "automation.builder.activate.author": "It runs on your word: what it does is asked of you before each step, and it pauses by itself if you lose that.",
    "automation.builder.activate.version": "Saving makes version {version}. Records already in the flow keep version {current}, the one they started with.",
    "automation.builder.activate.warnings.one": "One warning left to review (it does not stop it).",
    "automation.builder.activate.warnings.many": "{n} warnings left to review (they do not stop it).",
    "automation.builder.problem_at": "{where}: {problem}",
    "automation.builder.steps": "Steps",
    "automation.builder.activate.go": "Switch on now",
    "automation.builder.activate.save_version": "Save version {version}",
    "automation.builder.secret.title": "The web hook's key",
    "automation.builder.secret.once": "Shown this once: keep it where the other system checks the signature. It cannot be shown again.",
    "automation.builder.secret.kept": "I have kept it",
    "automation.builder.perf.unsaved": "Nothing to count yet",
    "automation.builder.perf.unsaved.lede": "A flow is counted once it is saved and switched on.",
    "automation.builder.perf.down": "The figures could not be read.",
    "automation.builder.perf.title": "The last {days} days",
    "automation.builder.perf.entered": "Came in",
    "automation.builder.perf.in_it": "Still in it",
    "automation.builder.perf.reached_goal": "Reached the goal",
    "automation.builder.perf.exited": "Left by an exit",
    "automation.builder.perf.goal_pct": "{pct}% of those who came in",
    "automation.builder.perf.no_entries": "Nobody came in yet",
    "automation.builder.perf.no_goal": "This flow has no goal",
    "automation.builder.runs": "Recent runs",
    "automation.builder.runs.lede": "Each record the flow took in, and what each step did and why.",
    "automation.builder.runs.down": "The runs could not be read.",
    "automation.builder.runs.empty": "No runs yet",
    "automation.builder.runs.expand": "Show the steps",
    "automation.builder.runs.collapse": "Hide the steps",
    "automation.builder.runs.steps": "Steps",
    "automation.builder.runs.when": "When",
    "automation.builder.runs.record": "Record",
    "automation.builder.runs.outcome": "Outcome",
    "automation.builder.runs.version": "Version",
    "automation.builder.runs.goal": "Reached the goal",
    "automation.builder.runs.step": "Step",
    "automation.builder.runs.type": "Kind",
    "automation.builder.runs.reason": "Why",
    "automation.builder.runs.no_steps": "No step ran.",
    "automation.builder.step_outcome.done": "Done",
    "automation.builder.step_outcome.failed": "Failed",
    "automation.builder.step_outcome.stopped": "Stopped",
    "automation.builder.test.title": "Safe test on one record",
    "automation.builder.test.lede": "The flow as it stands on this page, walked step by step.",
    "automation.builder.test.safe": "Nothing is sent and nothing is written: no notice, no activity, no message, no web hook, and it is not counted.",
    "automation.builder.test.behaviour": "What happens at each check?",
    "automation.builder.test.behaviour.yes": "What it waits for comes in time («yes»)",
    "automation.builder.test.behaviour.no": "The time runs out («no»)",
    "automation.builder.test.empty": "Add a step to test the flow.",
    "automation.builder.test.when": "When",
    "automation.builder.test.what": "What happens",
    "automation.builder.test.at_once": "At once",
    "automation.builder.test.after": "After {duration}",
    "automation.builder.test.entered": "The record comes in: «{event}»",
    "automation.builder.test.notify": "A notice would go out: «{title}»",
    "automation.builder.test.activity": "An activity would be made: «{title}»",
    "automation.builder.test.webhook": "The web hook would be called",
    "automation.builder.test.waited": "The wait of {duration} is over",
    "automation.builder.test.yes": "«{event}» came: on with «yes»",
    "automation.builder.test.no": "«{event}» did not come within {duration}: on with «no»",
    "automation.builder.test.end": "The record leaves the flow",
    "automation.builder.test.reached": "Test: {n}",
    "automation.builder.type.party_message": "Send a message",
    "automation.builder.type.signal": "Ask the module to act",
    "automation.builder.type.party_message.hint": "WhatsApp, SMS or email to the party, as a template",
    "automation.builder.type.signal.hint": "the module that owns the record does it — assign, move",
    "automation.builder.type.not_on_schedule": "{type} — not on a schedule: it needs a record",
    "automation.builder.unit.working_days": "Working days",
    "automation.builder.unit.working_days.one": "1 working day",
    "automation.builder.unit.working_days.two": "2 working days",
    "automation.builder.unit.working_days.few": "{n} working days",
    "automation.builder.unit.working_days.many": "{n} working days",
    "automation.builder.wait.working_days": "Counted on the workspace calendar: its weekend (Friday and Saturday) and its approved days off are skipped.",
    "automation.builder.weekday.0": "Sunday",
    "automation.builder.weekday.1": "Monday",
    "automation.builder.weekday.2": "Tuesday",
    "automation.builder.weekday.3": "Wednesday",
    "automation.builder.weekday.4": "Thursday",
    "automation.builder.weekday.5": "Friday",
    "automation.builder.weekday.6": "Saturday",
    "automation.builder.starts_from": "Starts from",
    "automation.builder.starts_from.event": "An event",
    "automation.builder.starts_from.schedule": "A schedule",
    "automation.builder.trigger.schedule_lede": "Every day or every week, at a time: about no record in particular.",
    "automation.builder.schedule.every": "How often",
    "automation.builder.schedule.every.day": "Every day",
    "automation.builder.schedule.every.week": "Every week",
    "automation.builder.schedule.weekday": "On",
    "automation.builder.schedule.at": "At",
    "automation.builder.schedule.clock": "Read on the workspace's clock: the time zone of its calendar.",
    "automation.builder.schedule.no_record": "A scheduled flow is about no record: it can tell people and call a web hook, but cannot send a message, make an activity, branch, ask a module to act, or let a record leave.",
    "automation.builder.sentence.schedule.day": "Every day at {at}",
    "automation.builder.sentence.schedule.week": "Every week on {day} at {at}",
    "automation.builder.sentence.message": "we send {channel} «{template}» to the party in «{field}»",
    "automation.builder.sentence.message.instead": " (if it cannot be sent, {instead})",
    "automation.builder.sentence.signal": "we ask the module to do «{key}»",
    "automation.builder.channel.whatsapp": "WhatsApp",
    "automation.builder.channel.sms": "SMS",
    "automation.builder.channel.email": "email",
    "automation.builder.pairs.name": "Name",
    "automation.builder.pairs.value": "Value",
    "automation.builder.pairs.remove": "Remove",
    "automation.builder.message.channel": "Channel",
    "automation.builder.message.purpose": "What it is for",
    "automation.builder.purpose.service": "Service — following up their request",
    "automation.builder.purpose.marketing": "Marketing — an offer or a promotion",
    "automation.builder.purpose.other": "Another purpose…",
    "automation.builder.message.purpose_key": "Purpose key",
    "automation.builder.message.purpose_key.hint": "A consent purpose the workspace keeps, in lower case.",
    "automation.builder.message.guard.service": "Consent is asked before every message: a party who did not agree to be contacted gets nothing. A service message goes in the workspace's service hours (08:00–22:00 unless it changed them).",
    "automation.builder.message.guard.marketing": "Marketing: it reaches only those who agreed to offers, and is never sent between 8 pm and 8 am (it waits for the morning).",
    "automation.builder.message.template": "Template",
    "automation.builder.message.template.hint": "One of the workspace's templates, by its key.",
    "automation.builder.message.template.hint_whatsapp": "WhatsApp goes only as a template Meta approved: those are offered.",
    "automation.builder.message.template.none": "The templates could not be listed: write the template's key.",
    "automation.builder.message.party_field": "Field that names the party",
    "automation.builder.message.party_field.hint": "The party's id in the event, as party_id.",
    "automation.builder.message.variables": "The template's words",
    "automation.builder.message.variables.hint": "A word as it is, or {{field}} to read it from the event.",
    "automation.builder.text.from_event.hint": "Write {{field}} to put in what the triggering event says, as {{name}}; a field it does not carry is left empty.",
    "automation.builder.message.value_hint": "A word, or {{field}}",
    "automation.builder.message.add_variable": "Add a word",
    "automation.builder.message.on_fail": "If it cannot be sent",
    "automation.builder.message.on_fail.hint": "No consent, no number or address, or the channel is not set up.",
    "automation.builder.message.on_fail.nothing": "Nothing: the flow goes on",
    "automation.builder.message.on_fail.notify": "A notice instead",
    "automation.builder.message.on_fail.activity": "An activity instead",
    "automation.builder.message.on_fail.notify_who": "The notice goes to the flow's author.",
    "automation.builder.signal.key": "What to ask for",
    "automation.builder.signal.key.hint": "module.what, as crm.lead.assign. The first part is the module asked.",
    "automation.builder.signal.permission": "Permission it takes",
    "automation.builder.signal.permission.hint": "One of that module's own, as crm.leads.manage: you must hold it.",
    "automation.builder.signal.params": "Values",
    "automation.builder.signal.params.hint": "Text, a number, true or false.",
    "automation.builder.signal.value_hint": "Text, a number, true or false",
    "automation.builder.signal.add_param": "Add a value",
    "automation.builder.signal.explain": "The module that owns the record decides and acts on it. It is asked of you when you save and before each run.",
    "automation.builder.warn.long_wait_working": "A long wait ({n} working days): whoever it is for may have moved on.",
    "automation.builder.warn.marketing": "A marketing message: everyone who did not agree to offers is skipped, and nothing goes at night.",
    "automation.builder.activate.what_schedule": "From now on it runs {when}, on the workspace's clock.",
    "automation.builder.test.scheduled": "The schedule comes round: {when}",
    "automation.builder.test.message": "A {channel} message «{template}» would be sent — or, if it cannot be, {instead}",
    "automation.builder.test.instead.nothing": "nothing else is done",
    "automation.builder.test.instead.notify": "a notice instead: «{title}»",
    "automation.builder.test.instead.activity": "an activity instead: «{title}»",
    "automation.builder.test.signal": "The module would be asked to do «{key}»",
    "automation.builder.test.waited_working": "The wait of {duration} is over",
    "automation.builder.test.calendar": "Working days are counted from today on the workspace calendar: Friday and Saturday are skipped here; the days off it approved are skipped too when it runs.",
    'change.field.automation_rule.name': 'Name',
    'change.field.automation_rule.trigger': 'When',
    'change.field.automation_rule.event_name': 'Event',
    'change.field.automation_rule.conditions': 'If',
    'change.field.automation_rule.actions': 'Do',
    'change.field.automation_rule.exit': 'Leaves when',
    'change.field.automation_rule.goal': 'Goal',
    'change.field.automation_rule.once_per_subject_days': 'Once every (days)',
    'change.field.automation_rule.next_run_at': 'Next run',
    'change.field.automation_rule.recipe': 'Recipe',
    'change.field.automation_rule.recipe_item': 'Recipe rule',
    'change.field.automation_rule.recipe_version': 'Recipe version',
    'change.field.automation_rule.status': 'Status',
    'change.field.automation_rule.paused_reason': 'Why it was paused',
    'change.field.automation_rule.sealed_secret': 'Web hook key',
    'change.field.automation_rule.active_from': 'Answers events from',
    'change.field.automation_rule.author_user': 'Runs on the word of',
    'change.field.automation_rule.created_by': 'Written by',
    'change.field.automation_rule.deleted_at': 'Removed on',
    'change.field.automation_rule.deleted_by': 'Removed by',
};
export const AUTOMATION_AR = {
    'nav.module.automation': 'الأتمتة',
    'automation.refusal.required': 'هذا الحقل مطلوب.',
    'automation.refusal.text': 'اكتب هذا نصًّا.',
    'automation.refusal.too_long': 'بحد أقصى {max} حرفًا.',
    'automation.refusal.number': 'عدد صحيح من {min} إلى {max}.',
    'automation.refusal.trigger': 'اختر ما يبدأ القاعدة.',
    'automation.refusal.trigger_not_yet': 'لا يبدأ تاريخٌ القاعدة بعد: اختر حدثًا أو جدولًا زمنيًّا.',
    'automation.refusal.schedule': 'اختر كل يوم أو كل أسبوع، ووقتًا بصيغة HH:MM، ويوم الأسبوع إن كانت أسبوعية.',
    'automation.refusal.schedule_event_field': 'القاعدة المجدولة لا تبدأ من حدث، فلا حقول لها تُختبر أو تُقرأ.',
    'automation.refusal.schedule_record': 'القاعدة المجدولة لا تخص سجلًا: لا تنشئ أنشطة ولا تتفرع ولا ترسل إشارات ولا تُدخل السجلات أو تُخرجها.',
    'automation.refusal.signal': 'اختر ما يُطلب من القائمة، مع قيمه.',
    'automation.refusal.signal_permission': 'اختر صلاحية من صلاحيات الوحدة المطلوب منها ({module}).',
    'automation.refusal.event': 'اختر حدثًا من القائمة.',
    'automation.refusal.event_own': 'لا تبدأ قاعدة مما تفعله الأتمتة نفسها.',
    'automation.refusal.subject': 'اختر السجل الذي يخصه الحدث.',
    'automation.refusal.field': 'اختر حقلًا من حقول الحدث.',
    'automation.refusal.operator': 'اختر طريقة مقارنة من القائمة.',
    'automation.refusal.value': 'هذه المقارنة تحتاج قيمة أخرى.',
    'automation.refusal.conditions': 'تعذّرت قراءة الشروط.',
    'automation.refusal.nesting': 'المجموعات مستوى واحد فقط، كما في القوائم.',
    'automation.refusal.too_many': 'بحد أقصى {max}.',
    'automation.refusal.action': 'اختر ما يُفعل.',
    'automation.refusal.action_type': 'اختر إجراءً من القائمة.',
    'automation.refusal.actions': 'يجب أن تفعل القاعدة شيئًا غير الانتظار.',
    'automation.refusal.trailing_wait': 'الانتظار في النهاية لا يؤخر شيئًا، فاحذفه.',
    'automation.refusal.wait_one': 'الانتظار دقائق أو أيام عمل، لا الاثنان.',
    'automation.refusal.channel': 'اختر واتساب أو رسالة نصية أو بريدًا أو بوابة الطرف.',
    'automation.refusal.portal_marketing': 'البوابة تحمل رسائل عن سجلات الطرف نفسه، ولا تحمل تسويقًا.',
    'automation.refusal.on_fail_message': 'الرسالة البديلة تُرسل على قناة أخرى، ولا بديل لها.',
    'automation.refusal.recipe_unknown': 'لا تشحن أي وحدة مفعّلة في مساحة العمل هذه وصفة «{value}».',
    'automation.refusal.recipe_empty': 'الوصفة «{value}» لا تشحن قواعد أتمتة.',
    'automation.refusal.recipe_invalid': 'إحدى قواعد هذه الوصفة ({item}) لا يمكن حفظها في مساحة العمل هذه. أبلغ فريق المنتج.',
    'automation.refusal.purpose': 'اختر الغرض من الرسالة.',
    'automation.refusal.template': 'اختر قالبًا تحتفظ به المساحة، واملأ كلماته.',
    'automation.refusal.on_fail': 'البديل تنبيه أو نشاط أو رسالة على قناة أخرى.',
    'automation.refusal.listen': 'اختر الحدث والحقل الذي يسمّي السجل فيه.',
    'automation.refusal.branch_last': 'التفرع آخر خطوة في قائمته: ضع ما بعده داخل فرعيه.',
    'automation.refusal.branch_depth': 'التفرع لا يتجاوز {max} مستويات.',
    'automation.refusal.record_needed': 'هذا يخص سجلًا بعينه: اختر حقل الحدث الذي يسمّيه.',
    'automation.refusal.roles': 'اختر {max} أدوار على الأكثر.',
    'automation.refusal.nobody': 'اختر من يُبلَّغ: أدوار، أو الشخص الذي يذكره الحدث، أو أنت.',
    'automation.refusal.importance': 'اختر معلومة أو تنبيهًا.',
    'automation.refusal.activity_kind': 'القاعدة تنشئ مهمة أو مكالمة.',
    'automation.refusal.activity_subject': 'النشاط يُحفظ على سجل، فاختر السجل الذي يخصه الحدث.',
    'automation.refusal.assignee': 'اختر عضوًا في مساحة العمل.',
    'automation.refusal.assignee_unnamed': 'تعذّرت قراءة الأعضاء، فاكتب اسم من يُسنَد إليه.',
    'automation.refusal.url': 'الويب هوك عنوان https بلا كلمة مرور فيه.',
    'automation.refusal.status': 'اختر فعّالة أو موقوفة.',
    'automation.refusal.action_not_permitted': 'لا تملك أن تجعل قاعدة تفعل هذا، فهو يحتاج {permission}.',
    'automation.refusal.no_key': 'الويب هوك غير مهيأ في هذا التثبيت بعد، فاسأل مشغّل المنصة.',
    'automation.refusal.active_limit': 'لا تعمل أكثر من {max} قاعدة في وقت واحد، فأوقف واحدة أولًا.',
    'automation.refusal.name_taken': 'هناك قاعدة أخرى بهذا الاسم.',
    'automation.refusal.not_found': 'لا توجد قاعدة كهذه.',
    'automation.refusal.stale': 'تغيّرت القاعدة منذ فتحتها. أعد التحميل وحاول مرة أخرى.',
    'automation.refusal.restore_expired': 'تُستعاد القاعدة خلال {days} يومًا من حذفها فقط.',
    'automation.reason.loop_guard': 'أُوقفت: عملت القاعدة على هذا السجل مرات كثيرة خلال ساعة.',
    'automation.reason.answered': 'وصل ما كان ينتظره: مضى في «نعم».',
    'automation.reason.message_not_sent': 'تعذّر إرسال الرسالة، ونُفّذ البديل المحدد.',
    'automation.reason.sent_instead': 'تعذّر إرسال الرسالة على قناتها، فأُرسلت على القناة الأخرى بدلًا منها.',
    'automation.reason.timed_out': 'انتهت المدة دون أن يصل شيء: مضى في «لا».',
    'automation.reason.exited': 'خرج من القاعدة بشرط خروج.',
    'automation.reason.goal_reached': 'بلغ هدف القاعدة.',
    'automation.reason.met_lately': 'لم يدخل: مرّت به القاعدة مؤخرًا.',
    'automation.reason.rule_paused': 'أُوقفت: القاعدة موقوفة أو محذوفة.',
    'automation.reason.author_not_permitted': 'أُوقفت: من حفظ القاعدة لم يعد يملك صلاحية ما تفعله.',
    'automation.reason.no_subject': 'الحدث لم يذكر السجل الذي يخصه.',
    'automation.reason.activity_refused': 'رُفض إنشاء النشاط.',
    'automation.reason.already_told': 'أُبلغوا من قبل.',
    'automation.reason.nobody_told': 'لم يُبلَّغ أحد.',
    'automation.reason.no_secret': 'ليس للقاعدة مفتاح ويب هوك.',
    'automation.reason.no_key': 'تعذّر فتح مفتاح الويب هوك في هذا التثبيت.',
    'automation.reason.webhook_answered': 'ردّ العنوان بخطأ.',
    'automation.reason.webhook_refused': 'هذا العنوان لا يُسمح للنظام بالوصول إليه.',
    'automation.reason.webhook_unreachable': 'العنوان لم يردّ.',
    'automation.reason.error': 'حدث خطأ أثناء تنفيذ هذه الخطوة.',
    // The follow-up flow builder and the list of flows (screens automation.rules and automation.builder).
    "nav.automation.rules": "مسارات المتابعة",
    "screen.automation.rules.title": "مسارات المتابعة",
    "screen.automation.rules.lede": "ما يحدث تلقائيًا حين يقع شيء لسجل: كل مسار يعمل باسم من كتبه.",
    "screen.automation.rules.empty": "لا مسارات بعد. يبدأ المسار الجديد من الحدث الذي يستجيب له.",
    "screen.automation.rules.stat.active": "مفعّلة",
    "screen.automation.rules.stat.paused": "موقوفة",
    "screen.automation.rules.stat.author_lost": "توقفت تلقائيًا",
    "screen.automation.rules.stat.author_lost.detail": "من كتبها لم يعد يملك صلاحية ما تفعله",
    "screen.automation.rules.column.name": "المسار",
    "screen.automation.rules.column.event_name": "يبدأ من",
    "screen.automation.rules.column.status": "الحالة",
    "screen.automation.rules.column.runs_7d": "مرات العمل خلال 7 أيام",
    "screen.automation.rules.column.last_run_at": "آخر مرة عمل",
    "screen.automation.rules.column.paused_reason": "سبب التوقف",
    "screen.automation.rules.column.version": "الإصدار",
    "screen.automation.rules.column.updated_at": "آخر تعديل",
    "screen.automation.rules.column.id": "المعرّف",
    "screen.automation.rules.action.create": "مسار جديد",
    "screen.automation.rules.action.open": "فتح",
    "screen.automation.rules.action.pause": "إيقاف مؤقت",
    "screen.automation.rules.action.resume": "إعادة التفعيل",
    "screen.automation.rules.action.remove": "حذف",
    "value.automation_rule.status.active": "مفعّل",
    "value.automation_rule.status.paused": "موقوف",
    "value.automation_rule.paused_reason.author_not_permitted": "فقد كاتبه الصلاحية",
    "screen.automation.builder.title": "مسار متابعة",
    "screen.automation.builder.lede": "ما يبدؤه، وما يحدث لكل سجل بالترتيب، ومتى يخرج السجل منه.",
    "value.automation_run.outcome.running": "جارٍ",
    "value.automation_run.outcome.done": "اكتمل",
    "value.automation_run.outcome.failed": "تعثّر",
    "value.automation_run.outcome.stopped": "توقف",
    "value.automation_run.outcome.skipped": "لم يدخل",
    "automation.builder.name": "اسم المسار",
    "automation.builder.name.placeholder": "كما يسميه الفريق: «عميل جديد — رد خلال دقائق»",
    "automation.builder.state.draft": "مسودة — لم تُحفظ",
    "automation.builder.state.active": "مفعّل · الإصدار {version}",
    "automation.builder.state.paused": "موقوف · الإصدار {version}",
    "automation.builder.unsaved": "تعديلات لم تُحفظ",
    "automation.builder.warnings.one": "تنبيه واحد",
    "automation.builder.warnings.many": "{n} تنبيهات",
    "automation.builder.runs_as": "يعمل باسم {name}: يُسأل عن صلاحيته قبل كل خطوة، ويتوقف المسار تلقائيًا إن فقدها.",
    "automation.builder.author_you": "أنت، حين تحفظه",
    "automation.builder.author_unknown": "العضو الذي حفظه آخر مرة",
    "automation.builder.read_only": "يمكنك الاطلاع على هذا المسار. تعديله يحتاج صلاحية إدارة قواعد الأتمتة.",
    "automation.builder.safe_test": "اختبار آمن",
    "automation.builder.pause": "إيقاف مؤقت",
    "automation.builder.save": "حفظ",
    "automation.builder.save_draft": "حفظ كمسودة",
    "automation.builder.save_changes": "حفظ التعديلات",
    "automation.builder.activate": "فعّل المسار",
    "automation.builder.back": "رجوع",
    "automation.builder.reload": "إعادة التحميل",
    "automation.builder.saved": "حُفظ موقوفًا: لا يعمل شيء قبل أن تفعّله.",
    "automation.builder.switched_on": "فُعّل المسار، ويستجيب للأحداث من الآن.",
    "automation.builder.saved_version": "حُفظ الإصدار {version}. من دخل المسار قبل ذلك يكمل على الإصدار الذي بدأ به.",
    "automation.builder.paused": "أُوقف المسار مؤقتًا، وأُلغي ما كان ينتظر.",
    "automation.builder.refused": "لم يُحفظ: يلزم تصحيح {n}، كلٌّ في موضعه.",
    "automation.builder.fix_first": "يلزم تصحيح {n} قبل الحفظ، كلٌّ مُعلَّم في موضعه.",
    "automation.builder.and_more": "و{n} غيرها",
    "automation.builder.removed": "حُذفت الخطوة.",
    "automation.builder.missing": "لا يوجد مسار كهذا",
    "automation.builder.down": "تعذّرت قراءة المسار",
    "automation.builder.down.lede": "ارجع إلى قائمة المسارات وافتحه من جديد.",
    "automation.builder.untitled": "بلا عنوان",
    "automation.builder.pick_or_write": "اختر، أو اكتب الاسم",
    "automation.builder.use_written": "استخدم «{text}»",
    "automation.builder.none_seen": "لم يُرصد شيء بعد",
    "automation.builder.yes": "نعم",
    "automation.builder.no": "لا",
    "automation.builder.sentence": "ماذا يحدث مع كل سجل",
    "automation.builder.sentence.lede": "اضغط أي جزء ملوّن لتعديل خطوته.",
    "automation.builder.sentence.start": "عندما يقع «{event}»",
    "automation.builder.sentence.conditions.one": " وتحقق شرطه",
    "automation.builder.sentence.conditions.two": " وتحقق شرطاه",
    "automation.builder.sentence.conditions.few": " وتحققت شروطه الـ{n}",
    "automation.builder.sentence.conditions.many": " وتحققت شروطه الـ{n}",
    "automation.builder.sentence.comma": "، ",
    "automation.builder.sentence.then": "، ثم ",
    "automation.builder.sentence.notify": "نبلّغ {who}: «{title}»",
    "automation.builder.sentence.activity": "ننشئ {kind} لـ{who}: «{title}»",
    "automation.builder.sentence.webhook": "نرسل الحدث إلى الويب هوك",
    "automation.builder.sentence.wait": "ننتظر {duration}",
    "automation.builder.sentence.branch": "إن وقع «{event}» خلال {duration}",
    "automation.builder.sentence.branch_yes": " — ",
    "automation.builder.sentence.branch_no": "؛ وإن لم يقع، ",
    "automation.builder.sentence.ends": "ينتهي المسار",
    "automation.builder.sentence.nothing": "لا يحدث شيء بعد",
    "automation.builder.sentence.stop": ".",
    "automation.builder.sentence.exit": " ويخرج السجل من المسار فور وقوع «{events}».",
    "automation.builder.sentence.or": "» أو «",
    "automation.builder.sentence.goal": " وهدفه: «{event}».",
    "automation.builder.sentence.once.one": " ولا يدخله السجل نفسه أكثر من مرة كل يوم.",
    "automation.builder.sentence.once.two": " ولا يدخله السجل نفسه أكثر من مرة كل يومين.",
    "automation.builder.sentence.once.few": " ولا يدخله السجل نفسه أكثر من مرة كل {n} أيام.",
    "automation.builder.sentence.once.many": " ولا يدخله السجل نفسه أكثر من مرة كل {n} يومًا.",
    "automation.builder.sentence.who.roles": "أصحاب الأدوار {roles}",
    "automation.builder.sentence.who.field": "الشخص المذكور في «{field}»",
    "automation.builder.sentence.who.author": "صاحب المسار",
    "automation.builder.sentence.who.member": "العضو المختار",
    "automation.builder.sentence.who.nobody": "لا أحد بعد",
    "automation.builder.sentence.list": "، ",
    "automation.builder.sentence.and": " و",
    "automation.builder.unit": "الوحدة",
    "automation.builder.unit.minutes": "دقائق",
    "automation.builder.unit.hours": "ساعات",
    "automation.builder.unit.days": "أيام",
    "automation.builder.unit.minutes.one": "دقيقة",
    "automation.builder.unit.minutes.two": "دقيقتين",
    "automation.builder.unit.minutes.few": "{n} دقائق",
    "automation.builder.unit.minutes.many": "{n} دقيقة",
    "automation.builder.unit.hours.one": "ساعة",
    "automation.builder.unit.hours.two": "ساعتين",
    "automation.builder.unit.hours.few": "{n} ساعات",
    "automation.builder.unit.hours.many": "{n} ساعة",
    "automation.builder.unit.days.one": "يوم",
    "automation.builder.unit.days.two": "يومين",
    "automation.builder.unit.days.few": "{n} أيام",
    "automation.builder.unit.days.many": "{n} يومًا",
    "automation.builder.mode.build": "البناء",
    "automation.builder.mode.performance": "الأداء",
    "automation.builder.mode.test": "الاختبار",
    "automation.builder.side.step": "الخطوة",
    "automation.builder.side.rules": "الضوابط",
    "automation.builder.start": "البداية",
    "automation.builder.end": "ينتهي المسار",
    "automation.builder.arm.yes": "نعم",
    "automation.builder.arm.no": "لا، انتهت المدة",
    "automation.builder.add_here": "أضف خطوة هنا",
    "automation.builder.add.title": "ماذا تضيف هنا؟",
    "automation.builder.add.lede": "اختر نوع الخطوة، وتوضع حيث ضغطت «+».",
    "automation.builder.add.go": "أضف الخطوة",
    "automation.builder.has_problem": "يلزم تصحيحه",
    "automation.builder.has_warning": "تنبيه",
    "automation.builder.remove_step": "احذف الخطوة",
    "automation.builder.drop_branch": "حذف هذا التحقق وفرعيه؟",
    "automation.builder.drop_branch.lede": "تُحذف معه الخطوات التي في «نعم» وفي «لا».",
    "automation.builder.selected": "الخطوة المختارة",
    "automation.builder.card.branch": "هل يقع «{event}» خلال {duration}؟",
    "automation.builder.type.notify": "تنبيه",
    "automation.builder.type.activity": "نشاط",
    "automation.builder.type.wait": "انتظر",
    "automation.builder.type.branch": "تحقق وتفرّع",
    "automation.builder.type.webhook": "ويب هوك",
    "automation.builder.type.notify.hint": "على جرس من تختار",
    "automation.builder.type.activity.hint": "مكالمة أو مهمة على السجل",
    "automation.builder.type.wait.hint": "يؤخر ما بعده",
    "automation.builder.type.branch.hint": "وقع / لم يقع خلال مدة",
    "automation.builder.type.webhook.hint": "استدعاء موقّع لنظام آخر",
    "automation.builder.type.branch_only_last": "تحقق وتفرّع — في آخر القائمة فقط",
    "automation.builder.kind.call": "مكالمة",
    "automation.builder.kind.task": "مهمة",
    "automation.builder.trigger": "متى يبدأ المسار؟",
    "automation.builder.trigger.lede": "حدث تعلنه أي وحدة، والحقل الذي يسمّي السجل فيه.",
    "automation.builder.event": "الحدث",
    "automation.builder.event.hint": "تُعرض الأحداث التي مرّت مؤخرًا، ويمكن كتابة غيرها.",
    "automation.builder.about_record": "الحدث يخص سجلًا بعينه",
    "automation.builder.no_record": "بلا سجل، يستطيع المسار التبليغ واستدعاء الويب هوك فقط، دون نشاط أو انتظار رد أو خروج.",
    "automation.builder.subject_field": "الحقل الذي يسمّي السجل",
    "automation.builder.subject_field.hint": "معرّف السجل في الحدث، مثل lead_id.",
    "automation.builder.subject_entity": "نوع السجل",
    "automation.builder.subject_entity.hint": "الوحدة.الكيان، مثل crm.lead.",
    "automation.builder.conditions": "وفقط إذا",
    "automation.builder.conditions.lede": "حقول الحدث، تُقارن كما تُصفّى القوائم. بلا شروط: كل حدث.",
    "automation.builder.conditions.rel": "يتحقق عندما",
    "automation.builder.conditions.all": "تتحقق كلها",
    "automation.builder.conditions.any": "يتحقق أيٌّ منها",
    "automation.builder.conditions.group": "مجموعة",
    "automation.builder.conditions.field": "الحقل",
    "automation.builder.conditions.op": "المقارنة",
    "automation.builder.conditions.value": "القيمة",
    "automation.builder.conditions.from": "من",
    "automation.builder.conditions.to": "إلى",
    "automation.builder.conditions.in_hint": "قيم تفصلها فواصل",
    "automation.builder.conditions.add": "أضف شرطًا",
    "automation.builder.conditions.add_group": "أضف مجموعة",
    "automation.builder.conditions.remove": "احذف الشرط",
    "automation.builder.conditions.remove_group": "احذف المجموعة",
    "automation.builder.op.eq": "يساوي",
    "automation.builder.op.contains": "يحتوي",
    "automation.builder.op.starts": "يبدأ بـ",
    "automation.builder.op.in": "واحد من",
    "automation.builder.op.gt": "أكبر من",
    "automation.builder.op.lt": "أقل من",
    "automation.builder.op.between": "بين",
    "automation.builder.op.on": "في يوم",
    "automation.builder.op.before": "قبل",
    "automation.builder.op.after": "بعد",
    "automation.builder.op.is": "نعم / لا",
    "automation.builder.notify.title": "نص التنبيه",
    "automation.builder.notify.importance": "الأهمية",
    "automation.builder.importance.info": "معلومة",
    "automation.builder.importance.warning": "تنبيه مهم",
    "automation.builder.notify.to_author": "بلّغ صاحب المسار",
    "automation.builder.notify.user_field": "بلّغ الشخص الذي يذكره الحدث",
    "automation.builder.notify.user_field.hint": "حقل يحمل عضوًا، مثل المسؤول عن السجل.",
    "automation.builder.notify.roles": "بلّغ هذه الأدوار",
    "automation.builder.notify.no_roles": "تعذّر سرد أدوار مساحة العمل: اكتب مفتاح الدور.",
    "automation.builder.notify.add_role": "أضف دورًا",
    "automation.builder.activity.kind": "النوع",
    "automation.builder.activity.due": "مستحق خلال (أيام)",
    "automation.builder.activity.due.hint": "0 لليوم نفسه.",
    "automation.builder.activity.title": "المطلوب",
    "automation.builder.activity.notes": "ملاحظات",
    "automation.builder.activity.assignee": "لمن",
    "automation.builder.activity.assignee.hint": "صاحب المسار، أو عضو في مساحة العمل.",
    "automation.builder.activity.assignee.no_members": "تعذّر سرد أعضاء مساحة العمل: يتولاها صاحب المسار، أو العضو الذي حُفظت له.",
    "automation.builder.activity.assignee.author": "صاحب المسار",
    "automation.builder.webhook.url": "العنوان",
    "automation.builder.webhook.url.hint": "عنوان https بلا كلمة مرور فيه.",
    "automation.builder.webhook.signed": "كل استدعاء موقّع بمفتاح خاص بهذا المسار، ويظهر مرة واحدة عند أول حفظ فيه ويب هوك.",
    "automation.builder.wait.for": "انتظر",
    "automation.builder.branch.until": "انتظر هذا الحدث",
    "automation.builder.branch.until.hint": "مثل «ردّ العميل».",
    "automation.builder.branch.field": "حقله الذي يسمّي السجل نفسه",
    "automation.builder.branch.field.hint": "حتى لا يُحسب رد عن سجل آخر.",
    "automation.builder.branch.within": "لمدة أقصاها",
    "automation.builder.branch.explain": "إن وقع قبل انتهاء المدة نمضي في «نعم» فورًا، وإن انتهت المدة نمضي في «لا» — المسار لا يتوقف بصمت.",
    "automation.builder.rules": "الضوابط",
    "automation.builder.rules.lede": "متى يخرج السجل من المسار، وما هدفه، وكم مرة يدخله السجل نفسه.",
    "automation.builder.rules.need_record": "هذه تحتاج أن تسمّي البداية سجلها.",
    "automation.builder.rules.exit": "يخرج السجل من المسار إذا",
    "automation.builder.rules.exit.lede": "ويُلغى ما كان ينتظره.",
    "automation.builder.rules.add_exit": "أضف حدثًا",
    "automation.builder.rules.remove_exit": "احذف الحدث",
    "automation.builder.rules.event": "الحدث",
    "automation.builder.rules.field": "الحقل الذي يسمّي السجل",
    "automation.builder.rules.goal": "الهدف",
    "automation.builder.rules.goal.lede": "بلوغه يُخرج السجل أيضًا، ويُحسب «بلغ الهدف».",
    "automation.builder.rules.has_goal": "لهذا المسار هدف",
    "automation.builder.rules.once": "مرة كل فترة",
    "automation.builder.rules.once.lede": "السجل الذي مرّ به المسار مؤخرًا لا يدخله من جديد.",
    "automation.builder.rules.has_once": "حدّد كم مرة يدخله السجل نفسه",
    "automation.builder.rules.once_days": "مرة واحدة على الأكثر كل",
    "automation.builder.warn.empty_no": "فرع «لا» فارغ: من لا يتحقق فيه الشرط يخرج من المسار دون متابعة.",
    "automation.builder.warn.nobody_acts": "لا شيء في المسار يطلب من شخص أن يتصرف.",
    "automation.builder.warn.long_wait": "انتظار طويل ({days} يومًا): قد ينسى صاحب الشأن طلبه.",
    "automation.builder.activate.title": "تفعيل «{name}»",
    "automation.builder.activate.title_version": "حفظ «{name}» إصدارًا {version}",
    "automation.builder.activate.what": "من الآن، كل «{event}» تتحقق فيه الشروط يبدأ هذا المسار. ولا يُعمل بما وقع قبل ذلك.",
    "automation.builder.activate.author": "يعمل باسمك: تُسأل صلاحيتك قبل كل خطوة، ويتوقف تلقائيًا إن فقدتها.",
    "automation.builder.activate.version": "الحفظ ينشئ الإصدار {version}. من هم داخل المسار يكملون على الإصدار {current} الذي بدؤوا به.",
    "automation.builder.activate.warnings.one": "بقي تنبيه واحد للمراجعة (لا يمنع التفعيل).",
    "automation.builder.activate.warnings.many": "بقيت {n} تنبيهات للمراجعة (لا تمنع التفعيل).",
    "automation.builder.problem_at": "{where}: {problem}",
    "automation.builder.steps": "الخطوات",
    "automation.builder.activate.go": "فعّل الآن",
    "automation.builder.activate.save_version": "احفظ الإصدار {version}",
    "automation.builder.secret.title": "مفتاح الويب هوك",
    "automation.builder.secret.once": "يظهر هذه المرة فقط: احفظه حيث يتحقق النظام الآخر من التوقيع، فلا يمكن عرضه مجددًا.",
    "automation.builder.secret.kept": "حفظته",
    "automation.builder.perf.unsaved": "لا شيء يُحصى بعد",
    "automation.builder.perf.unsaved.lede": "يُحصى المسار بعد حفظه وتفعيله.",
    "automation.builder.perf.down": "تعذّرت قراءة الأرقام.",
    "automation.builder.perf.title": "آخر {days} يومًا",
    "automation.builder.perf.entered": "دخلوا",
    "automation.builder.perf.in_it": "ما زالوا فيه",
    "automation.builder.perf.reached_goal": "بلغوا الهدف",
    "automation.builder.perf.exited": "خرجوا بشرط خروج",
    "automation.builder.perf.goal_pct": "{pct}% ممن دخلوا",
    "automation.builder.perf.no_entries": "لم يدخل أحد بعد",
    "automation.builder.perf.no_goal": "ليس لهذا المسار هدف",
    "automation.builder.runs": "آخر مرات العمل",
    "automation.builder.runs.lede": "كل سجل دخل المسار، وما فعلته كل خطوة ولماذا.",
    "automation.builder.runs.down": "تعذّرت قراءة مرات العمل.",
    "automation.builder.runs.empty": "لم يعمل المسار بعد",
    "automation.builder.runs.expand": "اعرض الخطوات",
    "automation.builder.runs.collapse": "أخفِ الخطوات",
    "automation.builder.runs.steps": "الخطوات",
    "automation.builder.runs.when": "متى",
    "automation.builder.runs.record": "السجل",
    "automation.builder.runs.outcome": "النتيجة",
    "automation.builder.runs.version": "الإصدار",
    "automation.builder.runs.goal": "بلغ الهدف",
    "automation.builder.runs.step": "الخطوة",
    "automation.builder.runs.type": "النوع",
    "automation.builder.runs.reason": "السبب",
    "automation.builder.runs.no_steps": "لم تعمل أي خطوة.",
    "automation.builder.step_outcome.done": "تمّت",
    "automation.builder.step_outcome.failed": "تعثّرت",
    "automation.builder.step_outcome.stopped": "توقفت",
    "automation.builder.test.title": "اختبار آمن على سجل واحد",
    "automation.builder.test.lede": "المسار كما هو في هذه الصفحة، خطوة بخطوة.",
    "automation.builder.test.safe": "لا يُرسل شيء ولا يُكتب شيء: لا تنبيه ولا نشاط ولا رسالة ولا ويب هوك، ولا يدخل في الأرقام.",
    "automation.builder.test.behaviour": "ماذا يحدث عند كل تحقق؟",
    "automation.builder.test.behaviour.yes": "يقع ما ينتظره في وقته («نعم»)",
    "automation.builder.test.behaviour.no": "تنتهي المدة («لا»)",
    "automation.builder.test.empty": "أضف خطوة لتختبر المسار.",
    "automation.builder.test.when": "متى",
    "automation.builder.test.what": "ماذا يحدث",
    "automation.builder.test.at_once": "فورًا",
    "automation.builder.test.after": "بعد {duration}",
    "automation.builder.test.entered": "يدخل السجل: «{event}»",
    "automation.builder.test.notify": "يُرسل تنبيه: «{title}»",
    "automation.builder.test.activity": "يُنشأ نشاط: «{title}»",
    "automation.builder.test.webhook": "يُستدعى الويب هوك",
    "automation.builder.test.waited": "انقضى انتظار {duration}",
    "automation.builder.test.yes": "وقع «{event}»: نمضي في «نعم»",
    "automation.builder.test.no": "لم يقع «{event}» خلال {duration}: نمضي في «لا»",
    "automation.builder.test.end": "يخرج السجل من المسار",
    "automation.builder.test.reached": "الاختبار: {n}",
    "automation.builder.type.party_message": "أرسل رسالة",
    "automation.builder.type.signal": "اطلب من الوحدة أن تتصرف",
    "automation.builder.type.party_message.hint": "واتساب أو رسالة نصية أو بريد للعميل، بقالب",
    "automation.builder.type.signal.hint": "الوحدة صاحبة السجل تنفّذ — إسناد، نقل مرحلة",
    "automation.builder.type.not_on_schedule": "{type} — لا يصلح مع الجدول: يحتاج سجلًا",
    "automation.builder.unit.working_days": "أيام عمل",
    "automation.builder.unit.working_days.one": "يوم عمل",
    "automation.builder.unit.working_days.two": "يومي عمل",
    "automation.builder.unit.working_days.few": "{n} أيام عمل",
    "automation.builder.unit.working_days.many": "{n} يوم عمل",
    "automation.builder.wait.working_days": "تُحسب على تقويم المنشأة: نتخطى عطلتها الأسبوعية (الجمعة والسبت) وإجازاتها المعتمدة.",
    "automation.builder.weekday.0": "الأحد",
    "automation.builder.weekday.1": "الاثنين",
    "automation.builder.weekday.2": "الثلاثاء",
    "automation.builder.weekday.3": "الأربعاء",
    "automation.builder.weekday.4": "الخميس",
    "automation.builder.weekday.5": "الجمعة",
    "automation.builder.weekday.6": "السبت",
    "automation.builder.starts_from": "يبدأ من",
    "automation.builder.starts_from.event": "حدث",
    "automation.builder.starts_from.schedule": "جدول زمني",
    "automation.builder.trigger.schedule_lede": "كل يوم أو كل أسبوع في وقت محدد: لا يخص سجلًا بعينه.",
    "automation.builder.schedule.every": "كم مرة",
    "automation.builder.schedule.every.day": "كل يوم",
    "automation.builder.schedule.every.week": "كل أسبوع",
    "automation.builder.schedule.weekday": "يوم",
    "automation.builder.schedule.at": "الساعة",
    "automation.builder.schedule.clock": "يُقرأ الوقت على ساعة المنشأة: المنطقة الزمنية لتقويمها.",
    "automation.builder.schedule.no_record": "المسار المجدول لا يخص سجلًا: يستطيع التبليغ واستدعاء الويب هوك، دون رسالة أو نشاط أو تفرّع أو طلب من وحدة أو خروج.",
    "automation.builder.sentence.schedule.day": "كل يوم الساعة {at}",
    "automation.builder.sentence.schedule.week": "كل أسبوع يوم {day} الساعة {at}",
    "automation.builder.sentence.message": "نرسل {channel} «{template}» إلى الطرف المذكور في «{field}»",
    "automation.builder.sentence.message.instead": " (وإن تعذّر الإرسال، {instead})",
    "automation.builder.sentence.signal": "نطلب من الوحدة «{key}»",
    "automation.builder.channel.whatsapp": "واتساب",
    "automation.builder.channel.sms": "رسالة نصية",
    "automation.builder.channel.email": "بريدًا",
    "automation.builder.pairs.name": "الاسم",
    "automation.builder.pairs.value": "القيمة",
    "automation.builder.pairs.remove": "احذف",
    "automation.builder.message.channel": "القناة",
    "automation.builder.message.purpose": "نوع الرسالة",
    "automation.builder.purpose.service": "خدمية — متابعة طلبه",
    "automation.builder.purpose.marketing": "تسويقية — عرض أو ترويج",
    "automation.builder.purpose.other": "غرض آخر…",
    "automation.builder.message.purpose_key": "مفتاح الغرض",
    "automation.builder.message.purpose_key.hint": "غرض موافقة تحفظه المنشأة، بحروف صغيرة.",
    "automation.builder.message.guard.service": "نسأل عن الموافقة قبل كل رسالة: من لم يوافق على التواصل لا تصله رسالة. الخدمية تُرسل في أوقات الخدمة لدى المنشأة (8 صباحًا – 10 مساءً ما لم تغيّرها).",
    "automation.builder.message.guard.marketing": "تسويقية: تصل فقط لمن وافق على العروض، ولا تُرسل بين 8 مساءً و8 صباحًا (تُؤجَّل للصباح).",
    "automation.builder.message.template": "القالب",
    "automation.builder.message.template.hint": "أحد قوالب المنشأة، بمفتاحه.",
    "automation.builder.message.template.hint_whatsapp": "واتساب لا يُرسل إلا بقالب اعتمدته Meta: هذه هي المعروضة.",
    "automation.builder.message.template.none": "تعذّر سرد القوالب: اكتب مفتاح القالب.",
    "automation.builder.message.party_field": "الحقل الذي يسمّي الطرف",
    "automation.builder.message.party_field.hint": "معرّف الطرف في الحدث، مثل party_id.",
    "automation.builder.message.variables": "كلمات القالب",
    "automation.builder.message.variables.hint": "كلمة كما هي، أو {{field}} لتُقرأ من الحدث.",
    "automation.builder.text.from_event.hint": "اكتب {{field}} ليُوضع ما يحمله الحدث المُطلِق، مثل {{name}}؛ والحقل الذي لا يحمله يُترك فارغاً.",
    "automation.builder.message.value_hint": "كلمة، أو {{field}}",
    "automation.builder.message.add_variable": "أضف كلمة",
    "automation.builder.message.on_fail": "إن تعذّر الإرسال",
    "automation.builder.message.on_fail.hint": "لا موافقة، أو لا رقم ولا عنوان، أو القناة غير مهيأة.",
    "automation.builder.message.on_fail.nothing": "لا شيء: يتابع المسار",
    "automation.builder.message.on_fail.notify": "تنبيه بدلًا منها",
    "automation.builder.message.on_fail.activity": "نشاط بدلًا منها",
    "automation.builder.message.on_fail.notify_who": "يذهب التنبيه إلى صاحب المسار.",
    "automation.builder.signal.key": "ماذا نطلب",
    "automation.builder.signal.key.hint": "الوحدة.الطلب، مثل crm.lead.assign. الجزء الأول هو الوحدة المطلوب منها.",
    "automation.builder.signal.permission": "الصلاحية التي يتطلبها",
    "automation.builder.signal.permission.hint": "إحدى صلاحيات تلك الوحدة، مثل crm.leads.manage: ويجب أن تملكها.",
    "automation.builder.signal.params": "القيم",
    "automation.builder.signal.params.hint": "نص أو رقم أو true أو false.",
    "automation.builder.signal.value_hint": "نص أو رقم أو true أو false",
    "automation.builder.signal.add_param": "أضف قيمة",
    "automation.builder.signal.explain": "الوحدة صاحبة السجل هي التي تقرر وتنفّذ. ويُسأل عن صلاحيتك عند الحفظ وقبل كل تشغيل.",
    "automation.builder.warn.long_wait_working": "انتظار طويل ({n} يوم عمل): قد يكون صاحبه انصرف.",
    "automation.builder.warn.marketing": "رسالة تسويقية: تتخطى كل من لم يوافق على العروض، ولا يُرسل شيء ليلًا.",
    "automation.builder.activate.what_schedule": "من الآن يعمل {when}، على ساعة المنشأة.",
    "automation.builder.test.scheduled": "حان موعد الجدول: {when}",
    "automation.builder.test.message": "تُرسل رسالة {channel} «{template}» — أو إن تعذّر إرسالها، {instead}",
    "automation.builder.test.instead.nothing": "لا يُفعل شيء آخر",
    "automation.builder.test.instead.notify": "تنبيه بدلًا منها: «{title}»",
    "automation.builder.test.instead.activity": "نشاط بدلًا منها: «{title}»",
    "automation.builder.test.signal": "يُطلب من الوحدة «{key}»",
    "automation.builder.test.waited_working": "انقضى انتظار {duration}",
    "automation.builder.test.calendar": "تُحسب أيام العمل من اليوم على تقويم المنشأة: نتخطى هنا الجمعة والسبت، وتُتخطى إجازاتها المعتمدة أيضًا عند التشغيل.",
    'change.field.automation_rule.name': 'الاسم',
    'change.field.automation_rule.trigger': 'متى',
    'change.field.automation_rule.event_name': 'الحدث',
    'change.field.automation_rule.conditions': 'إذا',
    'change.field.automation_rule.actions': 'افعل',
    'change.field.automation_rule.exit': 'يخرج عندما',
    'change.field.automation_rule.goal': 'الهدف',
    'change.field.automation_rule.once_per_subject_days': 'مرة كل (أيام)',
    'change.field.automation_rule.next_run_at': 'التشغيل التالي',
    'change.field.automation_rule.recipe': 'الوصفة',
    'change.field.automation_rule.recipe_item': 'قاعدة الوصفة',
    'change.field.automation_rule.recipe_version': 'إصدار الوصفة',
    'change.field.automation_rule.status': 'الحالة',
    'change.field.automation_rule.paused_reason': 'سبب الإيقاف',
    'change.field.automation_rule.sealed_secret': 'مفتاح الويب هوك',
    'change.field.automation_rule.active_from': 'تعمل على الأحداث من',
    'change.field.automation_rule.author_user': 'تعمل باسم',
    'change.field.automation_rule.created_by': 'كتبها',
    'change.field.automation_rule.deleted_at': 'حُذفت في',
    'change.field.automation_rule.deleted_by': 'حذفها',
};
//# sourceMappingURL=i18n-automation.js.map